// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"62247655","453":"9ca6a053"}[chunkId] + ".chunk.js";
};